module.exports = __webpack_public_path__ + "static/media/0025_IMG_LE_POISSONNIER.cfd8204a.webp";